<template>
    <div class="mainbody modulewrap">
        <ffbanner :infodata="infodata"></ffbanner>
        <div class="infopage2">
            <ffinfo :infolist="infolist"></ffinfo>
        </div>

    </div>
</template>



<script>
    export default {
        name: 'about',
        data() {
            return {
                infodata: {},
                infolist: []
            };
        },
        mounted() {

            this.$common.fetch({ 'act': 'tea_infomodel', 'exts': 'kv=6' }, res => {
                this.infodata = res.infodata;
                this.infolist = res.infodatainfo;
            });
        }
    }
</script>
